import { render, staticRenderFns } from "./TypewriterText.vue?vue&type=template&id=67f948a6&scoped=true"
import script from "./TypewriterText.vue?vue&type=script&lang=js"
export * from "./TypewriterText.vue?vue&type=script&lang=js"
import style0 from "./TypewriterText.vue?vue&type=style&index=0&id=67f948a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f948a6",
  null
  
)

export default component.exports